import { render, staticRenderFns } from "./TransferOwnership.vue?vue&type=template&id=b5bce5ae&scoped=true"
import script from "./TransferOwnership.vue?vue&type=script&lang=js"
export * from "./TransferOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bce5ae",
  null
  
)

export default component.exports